import {gql} from '@apollo/client'
import {Labels} from './parts/schema'

export const SYSTEM_ANNOUNCES = gql`
  query systemAnnounces($per: Int, $page: Int, $q: String, $label: SystemAnnounceLabel, $isImportant: Boolean) {
    systemAnnounces(per: $per, page: $page, q: $q, label: $label, isImportant: $isImportant) {
      totalCount
      list {
        id
        title
        link
        publishAt
        systemAnnounceType
        label
        labelName
      }
    }
  }
`
export interface SearchQuery {
  per: number
  page: number
  q: string
  label?: Labels
  isImportant?: boolean
}

export interface QueryResult {
  systemAnnounces: {
    totalCount: number
    list: SystemAnnounce[]
  }
}

export interface SystemAnnounce {
  id: string
  title: string
  link?: string
  publishAt: Date
  systemAnnounceType: string
  label?: Labels
  labelName?: string
}
